export const LOGIN_VIA_CODE_URL = '/login'
export const LOGIN_VIA_PASSWORD_URL = '/login/alternative'
export const SIGNUP_USER_URL = '/signup/user/:token'
